export const VERSION = "1.5.0";


// WEBPACK FOOTER //
// ./~/axios/lib/env/data.js